// extracted by mini-css-extract-plugin
export var measureBox = "_64-0";